import Vue from 'vue';
import _get from 'lodash/get';

/**
 * Sends an event to the tag manager in a consistently defined manner.
 * This will only track an event if the $gtm trackEvent function is defined on
 * the vue context.
 *
 * The event will consist of a:
 * - {String} category Defaulted to 'settlement
 * - {String} action Defaulted to enters
 * - {String} label Required field that can be anything
 * - {String} event Dash delineated concatenation of the category, action and label
 *
 * @param obj
 */
export default function sendSettlementEvent(obj = {}) {
  const { category = 'settlement', action = 'enters', ...rest } = obj;
  const trackEvent = _get(Vue, 'prototype.$gtm.trackEvent');

  if (rest.label && trackEvent) {
    trackEvent({
      event: `${category}-${action}-${rest.label}`,
      category,
      action,
      ...rest
    });
  }
}
